<template>
  <section class="primaryInfo">
    <a
      name="home"
      style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : ''
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
                     <ul class="crumbs_container">
                        <li
                        class="crumbs_item"
                        v-for="(routeItem, routeIdx) in crumbsList"
                        :key="routeIdx"
                        @click="gotoHandle(routeItem.routeName)"
                        >
                        {{ routeItem.label }}
                        <span v-if="routeIdx < crumbsList.length - 1">></span>
                        </li>
                    </ul>
                    <p class="prevTips">
                        You are currently viewing an archived version of the Privacy Policy.
                        View the<a href="/privacy"> current version </a> or
                        <a href="/archivedprivacy">all past versions</a>.
                    </p>
                    <h1>ToTok Privacy Policy</h1>
                    <h3>Last updated:  May 2020 <a href="/archivedprivacy">{{archivedVersionLabel}}</a></h3>
                    <!-- <h3>Last updated: August 2019 </h3> -->
                    

                    <p><strong>TOTOK</strong> (<strong>"Totok"</strong>, <strong>"totok"</strong>, <strong>"we"</strong>,
                        <strong>"us"</strong> or <strong>"our"</strong>)
                        are committed to protecting and respecting your privacy and personal data. 
                        This privacy policy sets out the basis on which any personal data we collect from you, 
                        or that you provide to us, 
                        through the use of our instant messaging application 
                        ToTok  (<strong>"ToTok"</strong> or the <strong>"App"</strong>), or any other service (together with the App, 
                        the <strong>"Services"</strong>), will be processed by us. Please read the following information carefully to fully 
                        understand our views and practices 
                        regarding your personal data and how we will treat it. 
                        For information regarding the general use of the Services, please see our 
                        <a href="https://totok.ai/terms">Terms of Use</a>.
                        For additional information regarding the security of the App, please visit <a href="https://totok.ai/security">here</a>.</p> 
                    <p>
                        To the extent the General Data Protection Regulation (the <strong>"GDPR"</strong>) applies to us when processing your personal data, 
                        the controller of your personal data is ToTok Technology Ltd.
                    </p>
                    <p>
                        If you wish to contact us with any questions in relation to this policy 
                        or our privacy practices, you may contact us by emailing <a href="mailto:privacy@totok.ai">privacy@totok.ai</a>
                        or by contacting us via the App.
                    </p>
                    <p>
                        We may update our privacy policy from time to time. 
                        If we make any material changes to how we treat your personal information, 
                        we will post the new privacy policy on our website and either notify you by email 
                        to the email address specified in your account or an in-App alert the first time you 
                        use the App after we make the change.
                    </p>
                    <p>
                       At all times, we keep our privacy practices and the terms of this policy under review to ensure your personal data is processed as securely as possible. 
                       This policy was last updated on the date given above. 
                       Any changes to this policy will be posted online, within the App and, 
                       if possible, emailed to you.
                    </p>
                    <h2>
                        Information We May Collect From You
                    </h2>
                    <p>
                        Personal data, or personal information, 
                        means any information about an individual from which that person can be identified. 
                        To provide you with the Services, we must collect, store, transfer, 
                        analyse and otherwise process certain of your personal data.
                    </p>
                    <p>
                        The Personal Data We Process Includes:
                    </p>
                    <ul>
                        <li>
                            <strong>Account data for the App or other Services:</strong>
                            you provide your mobile number and name to create your account. 
                            You may also provide other information to supplement your account including your gender, 
                            date of birth, email address, postal address and profile photo. 
                            Should you wish to ask us a query or make a complaint about our Services, such personal 
                            data will also be automatically added to your account;
                        </li>
                        <li>
                            <strong>Messages or calls:</strong>
                            your messages (including all photos, 
                            videos and other recordings) and calls are encrypted or double encrypted and generally speaking, 
                            we do not collect nor access any of the personal data or other information provided via your messages 
                            or calls. Your messages are stored on your own device and under your control whilst on your device. 
                            However, in certain circumstances, it is necessary that we store your messages, 
                            namely to comply with legal obligations to which we are subject and for the purpose of 
                            ensuring your messages are delivered when the recipient is offline at the time of 
                            sending by continually trying to deliver said messages. 
                            Our servers will store your messages until they are deleted 
                            in accordance with our retention practices (please see section 5).
                        </li>
                        <li>
                            <strong>Address book data:</strong>
                            we will request access to your device address book which, 
                            if granted, will allow us to access your contacts. 
                            If we have access, we can tell you which of your contacts is also using 
                            ToTok to make the experience more beneficial for you, for example 
                            if we have access to your address book, it is simple for you to select 
                            a contact from your address book to start a conversation with.
                        </li>
                        <li>
                            <strong>Photos, images, videos, voice recordings, and documents:</strong>
                            we will request access to the photos, images, videos, 
                            voice recordings and documents stored on your device to allow you to share said content with other ToTok users via the App. 
                            Providing us access will also allow any photos, images, videos, 
                            voice recordings and documents you receive from other ToTok users to be saved to your device. 
                        </li>
                        <li>
                            <strong>Location data:</strong>
                            we will request access to your location which, 
                            if granted, may be used for two functions within the App: 
                            (1) to allow you to share your location with other App users; and 
                            (2) to allow you to check the weather where you are. 
                        </li>
                        <li>
                            <strong>Data from other users:</strong>
                            we will collect your personal data when other users of the App interact with you, 
                            for example when they send you message. 
                            Further, such as when we access your address book with your consent as noted above, 
                            if another App user has your details in their address book and provides us consent to access, 
                            we will have access to your personal data.
                        </li>
                        <li>
                            <strong>Technical, usage and cookie data:</strong>
                            we collect information about your use of the Services, 
                            including how you use our Services, how often you use our Services, 
                            the types of interactions you frequently use our Services for (for example whether you only message or whether you message and call). 
                            We do this to better understand how to provide our Services, 
                            what our users like about our Services and our users don’t like about our Services. 
                            Such information may include, if applicable, your preferences, such as your language preference, internet protocol (IP) address, 
                            your account login data, browser type and version, browser plug-in types and versions, 
                            and other technology on the devices you use to access the Services.
                        </li>
                        <li>
                            <strong>Device information:</strong>
                            we collect information about the device you use to access the Services including the hardware model, 
                            the version of the App you are using, the mobile network, and the time zone setting.
                        </li>
                    </ul>
                    <h2>
                        How We Use Your Personal Data
                    </h2>
                    <p>
                        We use your personal data for the following reasons:
                    </p>
                    <ul>
                        <li>
                            to verify your account;
                        </li>
                        <li>
                            to provide you with, and operate, the Services;
                        </li>
                        <li>
                            to verify activity, and to promote safety and security on and off our Services. 
                            Should we believe you have breached our Terms of Use or are acting suspiciously, 
                            we may conduct an investigation to ensure you are not breaking the law;
                        </li>
                        <li>
                            to send you marketing materials, 
                            including in relation to other products and services provided by our group companies;
                        </li>
                        <li>
                            to respond to any of your queries;
                        </li>
                        <li>
                            to improve and customise our Services.
                        </li>
                    </ul>
                    
                        <p>We only process your personal data when it is lawful for us to do so. 
                        We rely on the following lawful grounds under the GDPR to process your personal data:</p>
                   <ul>
                        <li>
                                if you provide your consent, for example with respect to receiving marketing communications, 
                                allowing us to access your address book, camera or photos, or collect your location data;
                            </li>
                            <li>
                                the performance of the Terms of Use, which is a contract, 
                                you agree to when using our Services, for example to provide you with the Services;
                            </li>
                            <li>
                                compliance with a legal obligation to which we are subject, 
                                for example if we received a lawful request to disclose personal data;
                            </li>
                            <li>
                                to protect your vital interests or those of another natural person, 
                                for example if we are investigating a report of harmful conduct submitted by you;
                            </li>
                            <li>
                                performance of a task carried out in the public interest, 
                                for example to the extent this relates to the safety and security of our Service users and others; 
                                and/or
                            </li>
                            <li>
                                the legitimate interests pursued by us or by a third party as listed below, 
                                subject at all times to us ensuring your rights and freedoms do not outweigh the pursued interests.
                            </li>
                    </ul>
                    <p>The legitimate interests we pursue are</p>
                    <ul>
                        <li>
                            to constantly improve and customise our Services;
                        </li>
                        <li>
                            to ensure the safety and security of our Service users and third parties, 
                            and to promote such safety and security; and
                        </li>
                        <li>
                            to secure our Services from harmful acts such as cyber-security breaches.
                        </li>
                    </ul>
                    <h2>
                        Sharing Your Personal Data
                    </h2>
                    <p>
                        We may share your personal data in the following scenarios only:
                    </p>
                    <ul>
                        <li>
                            we may share your personal data with your consent;
                        </li>
                        <li>
                            we may share your personal data with other users who are using the App to ensure you both receive the full benefit 
                            of the Services offered.  You also use our Services to share your own personal data with other 
                            users of the Services;
                        </li>
                        <li>
                            by providing personal data to form part of your public profile on the App,
                             any personal data displayed on the public profile will be visible 
                             by other users of the App;
                        </li>
                        <li>
                            we may share your personal data to fulfil the purpose for which you provide it;
                        </li>
                        <li>
                            we may share your personal data if we are required to respond to law enforcement, 
                            officials, regulatory agencies and other lawful requests or legal processes, 
                            or to comply with a legal obligation to which we are subject;
                        </li>
                        <li>
                            we may share your personal data with if we undergo a merger, acquisition, sale or transfer of some of our assets, divestiture, restructuring or other form or reorganisation and pursuant to such, a third party will become the controller of your personal data; and/or
                        </li>
                        <li>
                            we may share your personal data with group companies if you request a good or service provided 
                            by one of our group companies, and that good or service strictly requires certain of 
                            the personal data that we hold about you to function or be provided (such as your name and mobile 
                            number if it is another application), or if one of our group companies provides us with 
                            services which relate to the provision of Services to you.
                        </li>
                    </ul>
                    <p>
                            If we are required to transfer your personal data to a country outside that in which 
                            we collected it pursuant to the above listed circumstances, 
                            we will do so in accordance with the applicable data privacy legislation. 
                            The lawful requirements will depend on the flow of personal data, meaning it will depend on 
                            whether the sharing of personal data is cross-border and which countries are involved. 
                            At all times, we will ensure a similar degree of protection is afforded to your personal data outside 
                            the country in which you are based.
                        </p>
                        <p>
                            If you are an EU citizen and we require to transfer your personal data outside the European Economic Area, 
                            we will ensure one of the following safeguards is in place:
                        </p>
                        <ul>
                            <li>
                                We will only transfer your personal data to countries that have been deemed 
                                to provide an adequate level of protection for personal data by the European Commission. 
                                For further details, see European Commission: Adequacy of the protection 
                                of personal data in non-EU countries.
                            </li>
                            <li>
                                Where we use certain service providers, 
                                we may use specific contracts approved by the European Commission 
                                which give personal data the same protection it has in Europe. 
                                For further details, see European Commission: Model contracts for the transfer 
                                of personal data to third countries.
                            </li>
                            <li>
                                Where we use providers based in the US, 
                                we may transfer data to them if they are part of the Privacy Shield which requires 
                                them to provide similar protection to personal data shared between Europe and the US. 
                                For further details, see European Commission: EU-US Privacy Shield.
                            </li>
                        </ul>
                    </ul>
                    <h2>
                        Security Of Your Personal Data
                    </h2>
                    <p>
                        We take your privacy very seriously and work hard to protect your data from being accidentally lost, 
                        used or accessed in an unauthorised way, altered or disclosed. 
                        We have put in place appropriate security measures to prevent this from happening, 
                        for example we use encryption tools to protect the content of your messages and calls. 
                        For additional information regarding the security of the App, please visit <a href="https://totok.ai/security">here</a>.
                    </p>
                    <p>
                        In addition, we limit access to your personal data to those employees, 
                        volunteers, agents, contractors and other third parties (as listed above) who have a need to know. 
                        They will only process your personal data on our 
                        instructions and they are subject to a duty of confidentiality.
                    </p>
                    <p>
                        Unfortunately, the transmission of information via the internet is not completely secure. 
                        Although we will do our best to protect your personal data, 
                        we cannot guarantee the security of your data transmitted through our Services; 
                        any transmission is at your own risk. Once we have received your information, 
                        we will use strict procedures and security features to try to prevent your data 
                        from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed.
                    </p>
                    <h2>
                        How Long We Keep Your Personal Data For
                    </h2>
                    <p>
                        We will only retain your personal data for as long as reasonably necessary to fulfil the purposes 
                        we collected it for, including for the purposes of satisfying any legal, 
                        regulatory, tax, accounting or reporting requirements. 
                        To determine the appropriate retention period for personal data, 
                        we consider the amount, nature and sensitivity of the personal data, 
                        the potential risk of harm from unauthorised use or disclosure of your personal data, 
                        the purposes for which we process your personal data and whether 
                        we can achieve those purposes through other means, and the applicable legal, 
                        regulatory, tax, accounting or other requirements.
                    </p>
                    <p>
                         With this in mind, we have determined that:
                    </p>
                    <ul>
                        <li>
                           for the reasons given above under section 1, 
                           messages will be stored for a period of up to six (6) months after being sent. 
                           This will allow us to continually try to deliver your messages should the recipient 
                           be offline and also to comply with our legal obligations; and
                        </li>
                        <li>
                            upon cancelling your account, we will store the personal data related to your account for up to one month from the date of cancellation before permanently deleting it.  Storing your data for this time means you can easily reactivate your account during this time.
                        </li>
                    </ul>
                    <p>
                        We may retain your personal data for a longer period in the event of a complaint or 
                        if we reasonably believe there is a prospect of litigation or other regulatory enforcement 
                        or action in respect to our relationship with you and/or your use of the Services.
                    </p>
                    <h2>
                       Your Rights
                    </h2>
                    <p>
                        In certain circumstances, you may have the right to:
                    </p>
                    <ul>
                        <li>
                            <strong>Request access</strong> to your personal data (commonly known as a "data subject access request"). 
                            This enables you to receive a copy of the personal 
                            data we hold about you and to check that we are lawfully processing it.
                        </li>
                        <li>
                            <strong>Request correction</strong> of the personal data that we hold about you. 
                            This enables you to have any incomplete or inaccurate data we hold about you corrected, 
                            though we may need to verify 
                            the accuracy of the new data you provide to us.
                        </li>
                        <li>
                            <strong>Request erasure</strong> of your personal data. 
                            This enables you to ask us to delete or remove personal data where there is 
                            no good reason for us continuing to process it. 
                            You also have the right to ask us to delete or remove your personal data where 
                            you have successfully exercised your right to object to processing (see below), 
                            where we may have processed your information unlawfully or 
                            where we are required to erase your personal data to comply with local law.
                        </li>
                        <li>
                            <strong>Object to processing</strong> of your personal data where we are relying on
                             a legitimate interest (or those of a third party) and there is something about
                              your particular situation which makes you want to object to 
                            processing on this ground as you feel it impacts on your fundamental rights and freedoms. 
                            You also have the right to object where we are processing your personal data for direct marketing purposes.
                        </li>
                        <li>
                            <strong>Request restriction of processing</strong> of your personal data. 
                            This enables you to ask us to suspend the processing of your personal data in certain scenarios.
                        </li>
                        <li>
                            <strong>Request the transfer</strong> of your personal data to you or to a third party. 
                            We will provide to you, or a third party you have chosen, your personal data in a structured, 
                            commonly used, machine-readable format.
                        </li>
                        <li>
                            <strong>Withdraw consent</strong> at any time where we are relying on consent to process your personal data.
                        </li>
                        <li>
                            <strong>Complain </strong>to the appropriate regulator for any data protection issues. 
                            We would, however appreciate the chance to deal with your concerns before you approach the 
                            regulator so please contact us in the first instance.
                        </li>
                    </ul>
                    <p>
                        To exercise one of the above rights, 
                        please contact us using the details provided above.
                    </p>
                    <p>
                        We may need to request specific information from you to help us confirm your identity 
                        and ensure you are able to exercise the right you wish to exercise. 
                        This is a security measure to ensure that personal data is not disclosed 
                        to any person who has no right to receive it. We may also contact you to 
                        ask you for further information in relation to your request to speed up our response.
                    </p>
                    <p>
                        We try to respond to all legitimate requests within one month. 
                        Occasionally it could take us longer than a month if your request is particularly 
                        complex or you have made a number of requests. 
                        In this case, we will notify you and keep you updated.
                    </p>
                    <h2>
                        Third Party Links
                    </h2>
                    <p>
                        Our Services may include links to third-party websites, 
                        plug-ins and applications. 
                        Clicking on those links or enabling those connections may allow 
                        third parties to collect or share data about you. 
                        We do not control these third-party websites, 
                        plug-ins and/or applications and are not responsible 
                        for their privacy statements. When you leave our App, 
                        we encourage you to read the privacy policy of every website 
                        or application you visit or use.
                    </p>
                    
                </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner ></FootBanner>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  metaInfo() {
    return {
      title: "Privacy Policy – Privacy and security, anywhere, anytime",
      meta: [
        {
          Description:
            "ToTok is fully committed to protecting and respecting your privacy and personal data."
        },
        { property: "og:title", content: "Privacy Policy – Privacy and security, anywhere, anytime" },
        { property: "og:url", content: "https://totok.ai/privacy" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png"
        },
        {
          property: "og:description",
          content:
            "ToTok is fully committed to protecting and respecting your privacy and personal data."
        },
        { property: "og:site_name", content: "ToTok" }
      ]
    };
  },
  components: {
    NavCrumbs,
    Footer,
    FootBanner
  },
  data() {
    return {
      crumbProp: {
        label: "Privacy & Terms",
        type: "simple"
      },
      archivedVersionLabel: "(archived versions)",
      mainPannel: "",
      showinfo: false,
      isActive: "privacy",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "terms"
        },
        {
          title: "Privacy Policy",
          anchorId: "privacy"
        }
      ]
    };
  },
  computed: {
    crumbsList() { 
        return [
            {
                label: "Privacy & Terms",
                routeName: "privacy",
            },
            {
                label: "Updates: Privacy Policy",
                routeName: "archivedprivacy",
            },
            {
                label: "May 2020",
                anchorId: "privacy-may-2020",
            },
        ];
    },
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(item) {
      switch (item) {
        case "terms":
          this.isActive = "terms";
          this.$router.push("terms");
          break;
        case "privacy":
          this.isActive = "privacy";
          this.$router.push("privacy");
          break;
      }
    }
  },
  mounted() {
    this.mainPannel = document.getElementById("mainbox");
  }
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .primaryInfo {
        // padding: 0.8rem;
        background: #fff;
        height: 82vh;

        div {
            margin-left 20px
            margin-right 20px
        }

        .leftMenu {
            display none
        }

        .info {

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                // padding-top: 40px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
            .crumbs_container{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                list-style: none;
                margin-left: 0px;
                padding-top: 20px;
                .crumbs_item{
                    color:#4377f2;
                    font-size:12px;
                    cursor pointer;
                    margin-left:10px;
                    span{
                        margin-left:10px;
                        color: #808080;
                    }
                }
                .crumbs_item:nth-child(1){
                    margin-left: 0px;
                }
                .crumbs_item:nth-last-child(1){
                    color: #808080;
                }
            }
            .prevTips{
                background: #e1e1e1;
                padding: 10px;
                border-radius: 4px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fff;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                width:800px;
                min-height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: flex-start;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 620px;
            margin: 20px 0;

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
            .crumbs_container{
                display: none;
            }
            .prevTips{
                background: #e1e1e1;
                padding: 10px;
                border-radius: 4px;
            }
        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
